import { numberOnlyRegex } from '@/common/regex'

export default {
    methods: {
        numberOnlyInput(e){
            const value = e.key
            if(!RegExp(numberOnlyRegex).test(value)) e.preventDefault();
        }
    }
}